import { render, staticRenderFns } from "./ym-profit-page.vue?vue&type=template&id=e45eb06a&scoped=true&"
import script from "./ym-profit-page.vue?vue&type=script&lang=js&"
export * from "./ym-profit-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45eb06a",
  null
  
)

export default component.exports